export function plural(
  value: number,
  options: { [key: number | string]: string; other: string },
): string {
  const directResult = options[value];
  if (directResult !== undefined) {
    return directResult;
  }

  return options.other;
}
